export enum EmployeePermissions {
    EmployeeOrders = 'EMPLOYEE_ORDERS',
}
